import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import { AxiosResponse } from 'axios';
import React, { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { Icons } from '../../../../assets/SvgIcons';
import { TaskViewType } from '../../../../config/enum';
import { TaskType } from '../../../../config/task';
import { ComponentHelper } from '../../../../helper/Infra';
import { ICTask, TaskResponse } from '../../../../helper/Interfaces';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../../store/feature/playBookDetailSlice';
import { getTaskHistory } from '../../../../store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import NewTask from '../../NewTask/NewTask';
import TodoCard from '../../TodoCard/TodoCard';
import { useLocation } from 'react-router-dom';
import {
  getPersonalTemplatesDetail,
  postProjectTemplateDetailTask,
} from '@Store/feature/personalTemplatesDetailSlice';

type TaskDetailRidCardProps = {
  allTasks: ICTask[];
  setAllTasks: (tasks: ICTask[]) => void;
  parentType: string;
  projectRelType: string;
  setopenParentModal?: (click: boolean) => void;
  disabled?: boolean;
  isUserImo?: boolean;
  updateTask?: (currentTask: ICTask, username: string) => void;
};

const TaskDetailRidCard: FC<TaskDetailRidCardProps> = ({
  allTasks,
  setAllTasks,
  parentType,
  projectRelType,
  setopenParentModal,
  isUserImo,
  disabled,
  updateTask,
}) => {
  const location = useLocation();

  let template = false;
  if (location.pathname.split('/')[1] === 'personal-templates-detail') {
    template = true;
  }

  const [openAddTaskPaper, setOpenAddTaskPaper] = useState<boolean>(false);
  const [createdRidTaskVisible, setCreatedRidTaskVisible] =
    useState<boolean>(false);
  const [createdRidTaskType, setCreatedRidTaskType] = useState<string>('');
  const [filterRidTaskType, setFilterRidTaskType] = useState<string>('');

  const componentHelper = new ComponentHelper();
  const anchorRef = useRef<HTMLDivElement>(null);
  const { selectedTask } = useAppSelector(getTaskHistory);
  const { tasks } = useAppSelector(getPersonalTemplatesDetail);

  const { dealTaskList } = useAppSelector(getPlayBookDetail);

  const dispatch = useAppDispatch();

  const handleToggle = () => {
    setOpenAddTaskPaper((prevOpen: boolean) => !prevOpen);
  };
  const updateTaskName = async (currentTask: ICTask, taskName: string) => {
    const data = (await componentHelper.updateTask({
      id: currentTask.id,
      name: taskName,
    })) as ICTask[];
    if (data.length > 0) {
      const newTaskList = [...dealTaskList];
      const index = dealTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = { ...newTaskList[index] };
      newVersion.name = taskName;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
      //setAllTasks([...newTaskList]);
    }
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpenAddTaskPaper(false);
  };

  const createdResponse = (response: AxiosResponse, type: string) => {
    if (
      response.status &&
      (response.status === 201 || response.status === 200)
    ) {
      const resp = response.data as TaskResponse;
      const newTask = resp.taskDto as ICTask[];
      setAllTasks([...newTask]);
      let patchAllTasks = template ? [...tasks] : [...dealTaskList];
      let headerTask = patchAllTasks.find(
        i => i.id === newTask[0].parentId
      ) as ICTask;

      if (headerTask) {
        patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
        const newHeaderTask = JSON.parse(JSON.stringify(headerTask)) as ICTask;
        switch (type) {
          case 'issue':
            newHeaderTask.issueCount = (newHeaderTask.issueCount ?? 0) + 1;

            break;
          case 'risk':
            newHeaderTask.riskCount = (newHeaderTask.riskCount ?? 0) + 1;

            break;
          case 'decision':
            newHeaderTask.decisionCount =
              (newHeaderTask.decisionCount ?? 0) + 1;

            break;

          default:
            break;
        }
        patchAllTasks.push(newHeaderTask);
      }
      patchAllTasks = [...patchAllTasks, ...newTask];
      if (template) {
        dispatch(postProjectTemplateDetailTask([...patchAllTasks]));
      } else {
        dispatch(postDealTaskList([...patchAllTasks]));
      }

      //setRefresh(!refresh);
    } else {
      toast(`There is an error while creating ${type}`);
    }
  };

  const createRiskTask = async (task: any) => {
    const createdRisk = await componentHelper.createRisk({
      name: task.name!,
      parentId: selectedTask?.id ?? '',
    } as any);
    createdResponse(createdRisk, 'risk');
  };

  const createIssueTask = async (task: ICTask) => {
    const createdIssue = await componentHelper.createIssue({
      name: task.name!,
      parentId: selectedTask?.id ?? '',
    });
    createdResponse(createdIssue, 'issue');
  };

  const createDecisionTask = async (task: ICTask) => {
    const createdDecision = await componentHelper.createDecision({
      name: task.name!,
      parentId: selectedTask?.id ?? '',
    });
    createdResponse(createdDecision, 'decision');
  };

  const filterButton = (name: string, type: string) => {
    return (
      <Button
        variant="contained"
        className={`badgeButton`}
        sx={{
          bgcolor: type === filterRidTaskType ? ' #5238db' : 'transparent',
          color: type !== filterRidTaskType ? '#615E84' : 'white',
        }}
        startIcon={
          type === 'risk' ? (
            <div style={{ marginTop: -2 }}>
              <Icons.Risks20
                color={type === filterRidTaskType ? 'white' : ''}
              />
            </div>
          ) : type === 'issue' ? (
            <div>
              <Icons.Issues20
                color={type === filterRidTaskType ? 'white' : ''}
              />
            </div>
          ) : type === 'decision' ? (
            <div>
              <Icons.Decision20
                color={type === filterRidTaskType ? 'white' : '#7D7A9A'}
              />
            </div>
          ) : null
        }
        endIcon={
          <Avatar
            sx={{
              bgcolor: type === filterRidTaskType ? '#7F77D9' : '#EBEBF0',
              width: 22,
              height: 19,
              fontSize: 11,
            }}
            variant="square"
          >
            <span
              style={{
                fontSize: 11,
                color: type === filterRidTaskType ? '#ffffff' : '#615E84',
              }}
            >
              {type === '' && allTasks?.length}
              {type === 'risk' &&
                allTasks?.filter(task => task.type === 'risk')?.length}
              {type === 'issue' &&
                allTasks?.filter(task => task.type === 'issue')?.length}
              {type === 'decision' &&
                allTasks?.filter(task => task.type === 'decision')?.length}
            </span>
          </Avatar>
        }
        onClick={() => {
          setFilterRidTaskType(type);
        }}
      >
        {name}
      </Button>
    );
  };

  const updateTaskDate = async (currentTask: ICTask, dueDate: string) => {
    const data = (await componentHelper.updateTask({
      id: currentTask.id,
      dueDate: dueDate === '' ? null : dueDate,
    })) as ICTask[];
    if (data.length > 0) {
      const newTaskList = template ? [...tasks] : [...dealTaskList];
      const index = dealTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = { ...newTaskList[index] };
      newVersion.dueDate = dueDate === '' ? null : dueDate;
      newTaskList[index] = newVersion;

      if (template) {
        dispatch(postProjectTemplateDetailTask(newTaskList));
      } else {
        dispatch(postDealTaskList(newTaskList));
      }
    }
  };

  const updateTaskProperty = async (
    taskId: string,
    taskProperty: string,
    value: any
  ) => {
    const updateTemplate = {
      id: taskId,
    };
    (updateTemplate as any)[taskProperty] = value;

    if (taskProperty === 'parentId') {
      const res = await componentHelper.changeParentTaskAndOrder(
        null,
        taskId,
        null,
        false
      );
      if (res.length && res.length > 0) {
        const changedTaskCollection = res as ICTask[];
        const legacyTaskList = JSON.parse(
          JSON.stringify(template ? tasks : dealTaskList)
        ) as ICTask[];
        let filteredTaskListList = [...legacyTaskList].filter(
          i => !changedTaskCollection.map(t => t.id).includes(i.id)
        );

        filteredTaskListList = [
          ...filteredTaskListList,
          ...changedTaskCollection,
        ];
        if (template) {
          dispatch(postProjectTemplateDetailTask(filteredTaskListList));
        } else {
          dispatch(postDealTaskList(filteredTaskListList));
        }
      }
      return;
    }

    const data = await componentHelper.updateTask(updateTemplate);
    if (data.errorCode) {
      toast(data?.message ?? 'Unknown Error');
      return;
    }
    if (data.length > 0) {
      const newTaskList = template ? [...tasks] : [...dealTaskList];
      const index = template
        ? tasks.findIndex(emp => emp.id === data[0].id)
        : dealTaskList.findIndex(emp => emp.id === data[0].id);
      const newVersion = { ...newTaskList[index] };
      (newVersion as any)[taskProperty] = value;
      newTaskList[index] = newVersion;
      if (template) {
        dispatch(postProjectTemplateDetailTask(newTaskList));
      } else {
        dispatch(postDealTaskList(newTaskList));
      }

      //setAllTasks([...newTaskList]);
    }
  };

  async function updateTaskRedux(currentTask: ICTask, deleteStatus?: string) {
    if (deleteStatus === 'init') {
      if (template) {
        dispatch(
          postProjectTemplateDetailTask(
            tasks.filter(task => task.id !== currentTask.id)
          )
        );
      } else {
        dispatch(
          postDealTaskList(
            dealTaskList.filter(task => task.id !== currentTask.id)
          )
        );
      }

      const deleteResponse = await componentHelper.deleteTask(currentTask.id!);
      localStorage.setItem(
        currentTask.id + 'delete',
        JSON.stringify(deleteResponse)
      );
      let patchAllTasks = [...dealTaskList];
      let headerTask = patchAllTasks.find(i => i.id === currentTask.parentId);
      if (headerTask) {
        patchAllTasks = patchAllTasks.filter(i => i.id !== headerTask?.id!);
        const newHeaderTask = JSON.parse(JSON.stringify(headerTask)) as ICTask;
        if (currentTask.type === 'risk') {
          newHeaderTask.riskCount = newHeaderTask.riskCount
            ? newHeaderTask.riskCount - 1
            : newHeaderTask.riskCount;
        } else if (currentTask.type === 'issue') {
          newHeaderTask.issueCount = newHeaderTask.issueCount
            ? newHeaderTask.issueCount - 1
            : newHeaderTask.issueCount;
        } else if (currentTask.type === 'decision') {
          newHeaderTask.decisionCount = newHeaderTask.decisionCount
            ? newHeaderTask.decisionCount - 1
            : newHeaderTask.decisionCount;
        }

        patchAllTasks.push(newHeaderTask);
      }
    } else if (deleteStatus === 'normal') {
      console.log('normal delete');
    } else if (deleteStatus === 'break') {
      await componentHelper.deleteUndoTask(
        currentTask.id!,
        JSON.parse(localStorage.getItem(currentTask.id + 'delete') ?? '')
      );
      if (template) {
        dispatch(postProjectTemplateDetailTask([...tasks, currentTask]));
      } else {
        dispatch(postDealTaskList([...dealTaskList, currentTask]));
      }
    }
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          marginBottom: 20,
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
          }}
        >
          {parentType !== 'risk' &&
            parentType !== 'issue' &&
            filterButton('All Items', '')}
          {!['risk', 'issue', 'decision'].includes(parentType) &&
            filterButton('Risks', 'risk')}
          {!['risk', 'issue', 'decision'].includes(parentType) &&
            filterButton('Issues', 'issue')}
          {!['decision'].includes(parentType) &&
            filterButton('Decision', 'decision')}
        </div>
        <div>
          {!(projectRelType === 'source' && !isUserImo) && (
            <ButtonGroup
              variant="contained"
              ref={anchorRef}
              aria-label="split button"
            >
              <Button
                className="custom-button-group"
                onClick={() => {
                  setCreatedRidTaskVisible(true);
                  setCreatedRidTaskType('all');
                }}
                disabled={disabled}
              >
                + Add new
              </Button>
              {parentType !== 'risk' && parentType !== 'issue' && (
                <Button
                  className="custom-button-group-icon"
                  size="small"
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle}
                  disabled={disabled}
                >
                  <ArrowDropDownIcon />
                </Button>
              )}
            </ButtonGroup>
          )}
          <Popper
            sx={{
              zIndex: 1,
            }}
            open={openAddTaskPaper}
            anchorEl={anchorRef.current}
            onResize={() => {}}
            onResizeCapture={() => {}}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                  marginTop: 10,
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList id="split-button-menu" autoFocusItem>
                      {!['risk', 'issue', 'decision'].includes(parentType) && (
                        <MenuItem
                          onClick={() => {
                            setCreatedRidTaskVisible(true);
                            setCreatedRidTaskType('risk');
                            setOpenAddTaskPaper(false);
                          }}
                        >
                          <Icons.Risks20 />{' '}
                          <span className={'ridMenuName'}>Create new risk</span>
                        </MenuItem>
                      )}
                      {!['risk', 'issue', 'decision'].includes(parentType) && (
                        <MenuItem
                          onClick={() => {
                            setCreatedRidTaskVisible(true);
                            setCreatedRidTaskType('issue');
                            setOpenAddTaskPaper(false);
                          }}
                        >
                          <Icons.Issues20 />{' '}
                          <span className={'ridMenuName'}>
                            {' '}
                            Create new issue{' '}
                          </span>
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={() => {
                          setCreatedRidTaskVisible(true);
                          setCreatedRidTaskType('decision');
                          setOpenAddTaskPaper(false);
                        }}
                      >
                        <Icons.Decision20 />{' '}
                        <span className={'ridMenuName'}>
                          Create new decision
                        </span>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
      <div>
        {allTasks
          ?.filter(task =>
            filterRidTaskType === '' ? task : task.type === filterRidTaskType
          )
          ?.map(task => (
            <TodoCard
              key={task.id}
              task={task}
              isFromList={true}
              startDate={task.startDate}
              subTaskCount={task.subTaskCount || 0}
              taskViewType={TaskViewType.LIST}
              isTypeVisible={true}
              deleteTask={(currentTask: ICTask, stopDelete?: string) => {
                updateTaskRedux(task, stopDelete);
              }}
              updateTaskName={updateTaskName}
              //updateTaskProperty={updateTaskDetailService}
              updateTaskProperty={updateTaskProperty}
              updateTask={updateTask}
              setopenParentModal={setopenParentModal}
              disabled={disabled}
              updateTaskDate={updateTaskDate}
            />
          ))}

        {createdRidTaskVisible && (
          <NewTask
            setnewTaskVisible={setCreatedRidTaskVisible}
            taskType={TaskType.Task}
            taskViewType={TaskViewType.LIST}
            task={selectedTask as ICTask}
            createRiskTask={
              createdRidTaskType === 'risk' ? createRiskTask : undefined
            }
            createDecisionTask={
              createdRidTaskType === 'decision' ? createDecisionTask : undefined
            }
            createIssueTask={
              createdRidTaskType === 'issue' ? createIssueTask : undefined
            }
            createdRidTaskType={createdRidTaskType}
            setCreatedRidTaskType={setCreatedRidTaskType}
            filterRidTaskType={filterRidTaskType}
          />
        )}

        {!createdRidTaskVisible &&
          projectRelType !== 'source' &&
          parentType === 'dependency' && (
            <button
              className="addNewButtonLink"
              style={{
                marginLeft: 30,
                marginTop: 20,
                marginBottom: 20,
              }}
              onClick={() => {
                setCreatedRidTaskVisible(true);
                setCreatedRidTaskType('all');
              }}
              disabled={disabled}
            >
              + Add new{' '}
            </button>
          )}

        {allTasks?.filter(task =>
          filterRidTaskType === '' ? task : task.type === filterRidTaskType
        ).length < 1 && (
          <Grid container justifyContent="center">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
              }}
            >
              <Icons.NoTask width={270} height={142} />
              {['risk', 'issue'].includes(parentType) ? (
                <Typography>No Decisions Yet.</Typography>
              ) : (
                <Typography>No RID items created yet.</Typography>
              )}
            </Box>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default TaskDetailRidCard;
